import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f79a0b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator" }, null, -1))
const _hoisted_4 = { class: "message" }
const _hoisted_5 = {
  key: 0,
  class: "title"
}
const _hoisted_6 = { class: "text" }

import { inject } from "vue";
    import { toastInjectionKey } from "./ToastManager";
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ToasterView',
  setup(__props) {

    const notifications = inject(toastInjectionKey);

    const onClick = function(id:string){
        notifications?.remove(id);
    }

return (_ctx: any,_cache: any) => {
  return (_unref(notifications) && _unref(notifications).length() > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications).toList(), (notification, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["toast", {
                'returning': notification.status === 'expired',
                'showing': notification.status === 'showing',
                'coming': notification.status === 'created',
                'warning': notification.type === 'warning',
                'alert': notification.type === 'alert',
                'info': notification.type === 'info',
                'success': notification.type === 'success'
            }]),
            onClick: ($event: any) => (onClick(notification.id))
          }, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              (notification.title.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(notification. title), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_6, _toDisplayString(notification.text), 1)
            ])
          ], 10, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})